<template>
  <div class="user">
    <div class="photo">
      <!--<img src="static/img/faces/face-2.jpg" alt="user avatar"/>-->

    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
        
         <span>
      		   <span v-if="user_info.first_name">{{user_info.first_name}} {{user_info.last_name}}</span>
        		<span v-else>Profile</span>
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#" @click.prevent="goToEditAccount">
                <span class="sidebar-mini-icon">A</span>
                <span class="sidebar-normal">Change Password</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="goToEditProfile">
                <span class="sidebar-mini-icon">U</span>
                <span class="sidebar-normal">Edit Profile</span>
              </a>
            </li>
            <li>
              <a href="#" style="display:none;">
                <span class="sidebar-mini-icon">S</span>
                <span class="sidebar-normal">Settings</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'
  import {TokenService} from 'src/services/storage.service'
  
  export default {
    components: {
      CollapseTransition
    },
    data() {
      return {
        isClosed: true,
        user_info:{
        	first_name: '',
        	last_name:'',
        },
      }
    },
    mounted() {
    	let u = JSON.parse(TokenService.getUserInfo());
    	if(u){
        	this.user_info = u;
        }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
       goToEditProfile(){
      		 this.$router.push( '/edit-profile')  
       },
       goToEditAccount(){
      		 this.$router.push( '/edit-account')  
       },
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
